import React from "react";

export const Nothing: React.FC = () => <svg viewBox="0 0 640 640"></svg>;

export const Stump: React.FC = () => (
  <svg viewBox="0 0 640 640">
    <path
      d="m346.73 548.49c-3.84-3.63-9-1.81-14.62 0-.97.32-23.54-5.5-19.24 0 5.7 7.31-31.64-7.31-25.94 0 8.26 10.59-18.91-12.24-20.98 0-7.39 43.84-16.58 57.83-54.16 91.51h196.11c-40.23-36.05-39.45-44.23-44.78-91.51-1.36-12.14-10.84 5.25-16.39 0z"
      fill="#bf6101"
    />
  </svg>
);

export const Lumberjack: React.FC = () => (
  <svg
    height="512"
    viewBox="0 0 128 128"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m66.016 80.695h-4.032a23.689 23.689 0 0 1 -23.689-23.689v-9.213h51.41v9.213a23.689 23.689 0 0 1 -23.689 23.689z"
      fill="#ffdaa8"
    />
    <path
      d="m64 80.695h2.016a23.689 23.689 0 0 0 23.689-23.689v-9.213h-25.705z"
      fill="#ffc373"
    />
    <path
      d="m113.94 108.68v6.29h-99.88v-6.29c0-11.96 9.7-22.64 21.66-22.64l13.67-1.25a7.051 7.051 0 0 0 5.63-4.95l1.27-4.29h15.42l1.27 4.29a7.051 7.051 0 0 0 5.63 4.95l13.67 1.25c11.96 0 21.66 10.68 21.66 22.64z"
      fill="#fcb740"
    />
    <path
      d="m92.28 86.04-13.67-1.25a7.051 7.051 0 0 1 -5.63-4.95l-1.27-4.29h-7.71v39.42h49.94v-6.29c0-11.96-9.7-22.64-21.66-22.64z"
      fill="#fc8800"
    />
    <path
      d="m64 95.261c6.165 0 11.238-5.03 11.93-11.506a7.044 7.044 0 0 1 -2.946-3.92l-1.269-4.281h-15.43l-1.269 4.281a7.044 7.044 0 0 1 -2.946 3.92c.692 6.476 5.765 11.506 11.93 11.506z"
      fill="#ffc373"
    />
    <path
      d="m74.741 71.413a5.472 5.472 0 0 0 -2.4.554 10.308 10.308 0 0 0 -16.693 0 5.472 5.472 0 0 0 -2.4-.554c-11.491-4.587-14.964-23.62-14.964-23.62v9.213a23.636 23.636 0 0 0 9.544 18.985 5.483 5.483 0 0 0 6.733 6.266 10.324 10.324 0 0 0 18.857 0 5.477 5.477 0 0 0 6.733-6.266 23.636 23.636 0 0 0 9.544-18.985v-9.213s-3.462 19.033-14.954 23.62z"
      fill="#d96200"
    />
    <path
      d="m33.65 104.69v10.28h-3.5v-10.28a1.75 1.75 0 0 1 3.5 0z"
      fill="#fc8800"
    />
    <path
      d="m97.84 104.69v10.28h-3.5v-10.28a1.75 1.75 0 0 1 3.5 0z"
      fill="#fcb740"
    />
    <path
      d="m32.7 53.39a5.6 5.6 0 0 0 5.6 5.6v-11.2a5.6 5.6 0 0 0 -5.6 5.6z"
      fill="#ffdaa8"
    />
    <path
      d="m95.3 53.39a5.6 5.6 0 0 0 -5.6-5.6v11.2a5.6 5.6 0 0 0 5.6-5.6z"
      fill="#ffc373"
    />
    <path
      d="m55.306 51.607a2.566 2.566 0 1 0 2.566 2.566 2.569 2.569 0 0 0 -2.566-2.566z"
      fill="#ff9f60"
    />
    <path
      d="m72.694 51.607a2.566 2.566 0 1 0 2.565 2.566 2.569 2.569 0 0 0 -2.565-2.566z"
      fill="#ff9f60"
    />
    <path
      d="m65 60.635-.637-.445 1.326-5.107a1.75 1.75 0 1 0 -3.387-.88l-1.632 6.283a1.749 1.749 0 0 0 .69 1.874l1.64 1.14a1.75 1.75 0 0 0 2-2.865z"
      fill="#ff9f60"
    />
    <rect
      fill="#ff415a"
      height="14.69"
      rx="2.57"
      width="54.2"
      x="36.9"
      y="33.1"
    />
    <path
      d="m58.608 13h10.784a17.858 17.858 0 0 1 17.858 17.858v2.242a0 0 0 0 1 0 0h-46.5a0 0 0 0 1 0 0v-2.24a17.858 17.858 0 0 1 17.858-17.86z"
      fill="#ff415a"
    />
    <path d="m45.187 85.174-7.25.661v29.102h7.25z" fill="#d96200" />
    <path d="m90.062 85.835-7.25-.661v29.763h7.25z" fill="#af4b00" />
    <path d="m33.65 109.828h16.6v5.109h-16.6z" fill="#ffffed" />
    <path d="m77.75 109.828h16.59v5.109h-16.59z" fill="#fff0c3" />
    <path
      d="m69.392 13h-5.392v20.1h23.25v-2.24a17.858 17.858 0 0 0 -17.858-17.86z"
      fill="#ce0050"
    />
    <path
      d="m73.429 82.256a5.477 5.477 0 0 0 6.733-6.266 23.636 23.636 0 0 0 9.544-18.985v-9.212s-3.473 19.033-14.964 23.62a5.472 5.472 0 0 0 -2.4.554 10.309 10.309 0 0 0 -8.342-4.259v20.667a10.329 10.329 0 0 0 9.429-6.119z"
      fill="#af4b00"
    />
    <path
      d="m88.53 33.1h-24.53v14.69h24.53a2.569 2.569 0 0 0 2.57-2.57v-9.55a2.569 2.569 0 0 0 -2.57-2.57z"
      fill="#ce0050"
    />
    <g fill="#9f0352">
      <path d="m44.25 33.1h3.5v14.69h-3.5z" />
      <path d="m53.25 33.1h3.5v14.69h-3.5z" />
      <path d="m62.25 33.1h3.5v14.69h-3.5z" />
      <path d="m71.25 33.1h3.5v14.69h-3.5z" />
      <path d="m80.25 33.1h3.5v14.69h-3.5z" />
    </g>
    <path
      d="m64 78.29a4.672 4.672 0 0 1 -4.667-4.667 1.75 1.75 0 0 1 3.5 0 1.167 1.167 0 0 0 2.333 0 1.75 1.75 0 1 1 3.5 0 4.672 4.672 0 0 1 -4.666 4.667z"
      fill="#ff9f60"
    />
    <g fill="#28092d">
      <path d="m100.043 85.718c-.2-.076-.4-.149-.6-.22a1.75 1.75 0 1 0 -1.152 3.3c.173.06.345.123.516.188a1.75 1.75 0 1 0 1.24-3.272z" />
      <path d="m105.229 88.5a1.75 1.75 0 1 0 -2.027 2.853 21.61 21.61 0 0 1 8.989 17.333v6.288a1.75 1.75 0 0 0 3.5 0v-6.288a25.162 25.162 0 0 0 -10.462-20.186z" />
      <path d="m96.095 102.937a1.75 1.75 0 0 0 -1.75 1.75v3.391h-2.533v-20.326l.306.028q.082.007.161.007a1.75 1.75 0 0 0 .157-3.493l-13.6-1.241c-.056-.01-.109-.032-.165-.044a7.259 7.259 0 0 0 3.329-6.092c0-.044 0-.088 0-.133a25.169 25.169 0 0 0 9.2-16.2 7.347 7.347 0 0 0 1.4-13.948 4.266 4.266 0 0 0 .258-1.415v-9.553a4.326 4.326 0 0 0 -4.32-4.321h-46.038v-.49a15.946 15.946 0 0 1 1.617-7.043 1.75 1.75 0 0 0 -3.146-1.533 19.423 19.423 0 0 0 -1.971 8.577v.537a4.312 4.312 0 0 0 -3.855 4.274v9.554a4.266 4.266 0 0 0 .258 1.415 7.347 7.347 0 0 0 1.409 13.95 25.093 25.093 0 0 0 5.178 12.13 1.75 1.75 0 0 0 2.749-2.167 21.636 21.636 0 0 1 -4.579-11.271c2.467 5.455 6.413 11.348 12.45 13.758a1.758 1.758 0 0 0 .649.125 3.711 3.711 0 0 1 1.631.379 1.75 1.75 0 0 0 2.178-.542 8.614 8.614 0 0 1 6.932-3.542 8.5 8.5 0 0 1 6.933 3.542 1.75 1.75 0 0 0 2.828-2.062 12.054 12.054 0 0 0 -18.673-1.038 7.169 7.169 0 0 0 -1.46-.227c-8.128-3.473-11.909-15.317-13.138-20.131h47.02c-1.037 4.065-3.9 13.137-9.671 17.968a1.75 1.75 0 1 0 2.246 2.69 30.7 30.7 0 0 0 7.756-10.93 21.736 21.736 0 0 1 -8.727 15.318 1.75 1.75 0 0 0 -.678 1.7 3.734 3.734 0 0 1 -4.592 4.27 1.75 1.75 0 0 0 -2.013.984 8.574 8.574 0 0 1 -15.664 0 1.749 1.749 0 0 0 -2.013-.984 3.736 3.736 0 0 1 -4.651-3.64 3.81 3.81 0 0 1 .059-.633 1.75 1.75 0 1 0 -3.45-.586 7.2 7.2 0 0 0 3.214 7.313c-.055.011-.107.034-.163.043l-13.522 1.232c-12.656.048-23.333 11.2-23.333 24.394v6.288a1.75 1.75 0 0 0 3.5 0v-6.288c0-11.326 9.12-20.894 19.914-20.894.053 0 .106 0 .159-.007l.306-.028v20.326h-2.532v-3.391a1.75 1.75 0 0 0 -3.5 0v10.282a1.75 1.75 0 0 0 3.5 0v-3.391h14.845v3.36a1.75 1.75 0 0 0 3.5 0v-5.11a1.75 1.75 0 0 0 -1.75-1.75h-10.563v-20.645l3.75-.342v16.409a1.75 1.75 0 1 0 3.5 0v-16.729l2.611-.238c.041 0 .082-.009.123-.016a8.813 8.813 0 0 0 4.212-1.923 12.015 12.015 0 0 0 20.111.18c-1.054 5.057-5.167 8.737-9.994 8.737a9.908 9.908 0 0 1 -8.087-4.335 1.75 1.75 0 0 0 -2.851 2.03 13.365 13.365 0 0 0 10.938 5.805c6.249 0 11.593-4.487 13.234-10.754a8.745 8.745 0 0 0 1.1.26c.04.007.081.012.122.016l9.86.9v20.645h-3.75v-16.578a1.75 1.75 0 1 0 -3.5 0v16.578h-3.316a1.75 1.75 0 0 0 -1.75 1.75v5.11a1.75 1.75 0 0 0 3.5 0v-3.36h14.845v3.391a1.75 1.75 0 0 0 3.5 0v-10.282a1.75 1.75 0 0 0 -1.75-1.75zm-4.64-46.137v-6.817a3.816 3.816 0 0 1 0 6.814zm-2.1-21.129v9.554a.821.821 0 0 1 -.82.82h-4.785v-11.197h4.784a.822.822 0 0 1 .82.82zm-34.355.912a1.75 1.75 0 0 0 -1.75 1.75v7.709h-5.5v-11.194h14.5v11.194h-5.5v-7.709a1.75 1.75 0 0 0 -1.75-1.75zm10.75-1.736h5.5v6.319a1.75 1.75 0 0 0 3.5 0v-6.318h5.5v11.194h-14.5zm-27.1.821a.822.822 0 0 1 .821-.821h4.779v11.195h-4.784a.822.822 0 0 1 -.821-.82zm-4.2 17.722a3.837 3.837 0 0 1 2.1-3.407v6.817a3.838 3.838 0 0 1 -2.103-3.41z" />
      <path d="m52.74 54.173a2.566 2.566 0 1 0 2.566-2.566 2.569 2.569 0 0 0 -2.566 2.566z" />
      <path d="m72.694 51.607a2.566 2.566 0 1 0 2.565 2.566 2.569 2.569 0 0 0 -2.565-2.566z" />
      <path d="m64.44 52.949a1.753 1.753 0 0 0 -2.134 1.251l-1.632 6.283a1.749 1.749 0 0 0 .69 1.874l1.636 1.143a1.75 1.75 0 0 0 2-2.865l-.637-.445 1.326-5.107a1.75 1.75 0 0 0 -1.249-2.134z" />
      <path d="m46 19.961a1.743 1.743 0 0 0 1.234-.509q.247-.245.5-.48a1.75 1.75 0 1 0 -2.362-2.583q-.311.284-.609.582a1.75 1.75 0 0 0 1.237 2.99z" />
      <path d="m51.522 16.388a15.953 15.953 0 0 1 7.086-1.638h10.785a16.021 16.021 0 0 1 15.7 12.5 1.75 1.75 0 1 0 3.412-.779 19.5 19.5 0 0 0 -19.112-15.221h-10.785a19.415 19.415 0 0 0 -8.628 2 1.75 1.75 0 1 0 1.542 3.142z" />
      <path d="m68.667 73.624a1.75 1.75 0 1 0 -3.5 0 1.167 1.167 0 0 1 -2.333 0 1.75 1.75 0 0 0 -3.5 0 4.667 4.667 0 0 0 9.333 0z" />
    </g>
  </svg>
);

export const Door: React.FC = () => (
  <svg
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m104 32v480h304v-480zm136 456h-112v-192h112zm0-240h-112v-192h112zm144 240h-112v-192h112zm0-240h-112v-192h112z"
      fill="#af6328"
    />
    <path d="m368 232v-160l16-16v192h-112l16-16z" fill="#7f4122" />
    <g fill="#a25425">
      <path d="m304 88v128l-16 16h80v-160l-16 16z" />
      <path d="m288 72h80l16-16h-112v192l16-16z" />
      <path d="m160 88v128l-16 16h80v-160l-16 16z" />
      <path d="m144 72h80l16-16h-112v192l16-16z" />
    </g>
    <path d="m304 88v128l-16 16v-160h80l-16 16z" fill="#af6328" />
    <path d="m224 232v-160l16-16v192h-112l16-16z" fill="#7f4122" />
    <path d="m160 88v128l-16 16v-160h80l-16 16z" fill="#af6328" />
    <path d="m160 328v128l-16 16h80v-160l-16 16z" fill="#a25425" />
    <path d="m144 312h80l16-16h-112v192l16-16z" fill="#a25425" />
    <path d="m224 472v-160l16-16v192h-112l16-16z" fill="#7f4122" />
    <path d="m160 328v128l-16 16v-160h80l-16 16z" fill="#af6328" />
    <path d="m304 328v128l-16 16h80v-160l-16 16z" fill="#a25425" />
    <path d="m288 312h80l16-16h-112v192l16-16z" fill="#a25425" />
    <path d="m368 472v-160l16-16v192h-112l16-16z" fill="#7f4122" />
    <path d="m304 328v128l-16 16v-160h80l-16 16z" fill="#af6328" />
    <path
      d="m376 264h-48c-4.418 0-8 3.582-8 8s3.582 8 8 8h40c0 4.418 3.582 8 8 8s8-3.582 8-8v-8c0-4.418-3.582-8-8-8z"
      fill="#f6b74e"
    />
  </svg>
);

export const Tree: React.FC = () => (
  <svg viewBox="0 0 512.001 512.001" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m485.271 240.532c0-35.798-21.77-66.511-52.792-79.623 5.478-10.59 8.592-22.602 8.592-35.348 0-42.561-34.502-77.063-77.063-77.063-12.126 0-23.593 2.809-33.799 7.798-9.068-32.469-38.847-56.296-74.209-56.296s-65.14 23.827-74.209 56.296c-10.206-4.99-21.673-7.798-33.799-7.798-42.561 0-77.063 34.502-77.063 77.063 0 12.746 3.113 24.758 8.592 35.348-31.022 13.113-52.792 43.825-52.792 79.623 0 46.393 36.576 84.196 82.459 86.265 6.397 23.17 31.1 40.443 60.622 40.443 16.732 0 31.91-5.557 43.095-14.581 11.186 9.024 26.364 14.581 43.095 14.581s31.91-5.557 43.095-14.581c11.186 9.024 26.364 14.581 43.095 14.581 29.522 0 54.225-17.273 60.622-40.444 45.883-2.069 82.459-39.871 82.459-86.264z"
      fill="#129b12"
    />
    <path
      d="m251.377.153c-.949.057-1.894.125-2.833.217-.288.028-.574.06-.86.091-1.009.109-2.013.235-3.01.383-.187.027-.374.054-.56.083-1.186.185-2.366.391-3.534.629-.002 0-.004.001-.006.001 20.23 4.114 39.171 18.204 51.171 35.964 8.498 12.577 23.017 19.827 38.161 18.797.101-.007.201-.014.302-.021-9.067-32.47-38.846-56.297-74.208-56.297-1.24 0-2.471.036-3.696.094-.31.015-.617.041-.927.059z"
      fill="#097c09"
    />
    <path
      d="m432.479 160.909c5.479-10.59 8.592-22.602 8.592-35.348 0-42.561-34.502-77.063-77.063-77.063-5.282 0-10.438.534-15.42 1.548 35.166 7.147 61.633 38.239 61.633 75.515 0 12.746-3.113 24.758-8.592 35.348 31.022 13.113 52.792 43.825 52.792 79.623 0 46.393-36.576 84.195-82.458 86.264-5.243 18.991-22.787 34.012-45.199 38.816 4.933 1.059 10.1 1.627 15.427 1.627 29.522 0 54.225-17.273 60.622-40.444 45.883-2.069 82.458-39.871 82.458-86.264 0-35.797-21.768-66.51-52.792-79.622z"
      fill="#097c09"
    />
    <path
      d="m200.82 339.895c-6.95 11.788-35.752 24.969-46.433 25.718 1.175.252 2.366.472 3.567.668.096.016.192.033.289.048 1.217.193 2.446.359 3.688.492.032.003.064.005.096.009 1.117.118 2.246.203 3.381.27.276.016.553.032.831.046 1.183.057 2.372.095 3.572.095 15.26 0 29.216-4.633 40.042-12.292l1.898-1.38-9.666-15.859z"
      fill="#009000"
    />
    <path
      d="m294.533 359.573 33.016-52.099c2.612-4.121 1.821-9.532-1.86-12.734-3.931-3.419-9.842-3.196-13.504.511l-24.315 24.617c-3.225 3.265-8.75.55-8.136-3.997l7.15-52.976c.764-5.66-3.42-10.786-9.119-11.171l-6.699-.453c-5.034-.34-9.514 3.17-10.389 8.139l-12.763 72.513c-.71 4.033-5.831 5.363-8.414 2.187l-39.972-49.159c-2.766-3.402-7.444-4.572-11.485-2.873l-6.999 2.941c-5.541 2.329-7.733 9.027-4.641 14.181l41.076 68.467c5.948 9.915 8.401 21.547 6.914 33.014-5.323 41.057-11.936 79.778-38.997 111.32h141.204c-28.968-33.766-36.114-75.757-39.948-120.035-.981-11.371 1.772-22.754 7.881-32.393z"
      fill="#bf6101"
    />
    <path
      d="m327.549 307.474c2.612-4.121 1.822-9.532-1.86-12.734-3.931-3.419-9.842-3.196-13.504.511l-10.859 10.993-13.456 13.623c-3.225 3.265-8.75.55-8.136-3.997l7.15-52.976c.745-5.517-3.216-10.514-8.694-11.12l-20.105 124.965c-.338 1.614-.602 3.243-.786 4.884-.383 3.415-.434 6.878-.135 10.341 3.836 44.279 10.982 86.27 39.95 120.036h29.488c-28.968-33.766-36.114-75.757-39.948-120.035-.984-11.37 1.77-22.752 7.878-32.392z"
      fill="#9a4d01"
    />
    <path
      d="m241.333 60.5c-21.621 0-40.232 12.832-48.669 31.29-8.716-6.159-19.346-9.79-30.831-9.79-29.547 0-53.5 23.953-53.5 53.5 0 9.749 2.621 18.881 7.177 26.752-25.656 3.945-45.304 26.115-45.304 52.875 0 29.547 23.953 53.5 53.5 53.5s171.127-125.08 171.127-154.627-23.951-53.5-53.5-53.5z"
      fill="#28a528"
    />
  </svg>
);

interface Props {
  className?: string;
}

export const Lumber: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    height="512"
    viewBox="0 0 512 512"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m223.153 98.596c9.289 25.556-17.499 47.27-21.58 50.391-.336.257-.732.401-1.154.419-5.134.227-39.626.773-48.916-24.783-13.513-37.174 7.48-69.065 11.979-75.279.492-.679 1.338-.987 2.152-.781 7.439 1.878 44.007 12.859 57.519 50.033z"
      fill="#ffca28"
    />
    <path
      d="m223.153 98.596c-13.153-36.187-48.144-47.55-56.855-49.861 11.1 7.675 22.513 19.349 28.852 36.789 9.289 25.556-17.499 47.27-21.58 50.391-.336.257-.732.401-1.154.419-1.834.081-7.424.196-14.265-.846 13.51 14.5 38.005 14.106 42.268 13.918.422-.019.819-.163 1.154-.419 4.082-3.121 30.87-24.835 21.58-50.391z"
      fill="#ffb300"
    />
    <path
      d="m226.29 196.841-42.054-115.692c-1.415-3.891-5.718-5.9-9.61-4.486-3.894 1.414-5.903 5.715-4.488 9.607l42.053 115.692c3.387 9.316 17.49 4.209 14.099-5.121z"
      fill="#bf6724"
    />
    <path
      d="m346.54 389.022c0 41.132-28.866 74.478-64.479 74.478h-217.575v-148.947h217.574c35.614 0 64.48 33.347 64.48 74.469z"
      fill="#8c4815"
    />
    <ellipse cx="64.484" cy="389.026" fill="#ffe8cf" rx="64.484" ry="74.472" />
    <path
      d="m428.641 255.942c0 41.132-28.866 74.478-64.479 74.478h-217.574v-148.947h217.574c35.613 0 64.479 33.347 64.479 74.469z"
      fill="#a35418"
    />
    <path
      d="m512 389.022c0 41.132-28.866 74.478-64.479 74.478h-217.574v-148.947h217.574c35.613 0 64.479 33.347 64.479 74.469z"
      fill="#bf6724"
    />
    <g fill="#8c4815">
      <path d="m302.691 237.329c0-4.14-3.358-7.497-7.5-7.497h-86.152c-4.142 0-7.5 3.357-7.5 7.497s3.358 7.497 7.5 7.497h86.152c4.142 0 7.5-3.356 7.5-7.497z" />
      <path d="m426.06 276.842c-1.32 5.258-3.14 10.286-5.39 14.994h-125.48c-4.14 0-7.5-3.349-7.5-7.497 0-4.138 3.36-7.497 7.5-7.497z" />
      <path d="m341.729 244.826h29.244c4.142 0 7.5-3.357 7.5-7.497s-3.358-7.497-7.5-7.497h-29.244c-4.142 0-7.5 3.357-7.5 7.497 0 4.141 3.358 7.497 7.5 7.497z" />
    </g>
    <g fill="#a35418">
      <path d="m448.021 363.033c0-4.14-3.358-7.497-7.5-7.497h-150.132c-4.142 0-7.5 3.357-7.5 7.497s3.358 7.497 7.5 7.497h150.132c4.143 0 7.5-3.356 7.5-7.497z" />
      <path d="m508.63 412.838c-1.55 5.288-3.59 10.316-6.08 14.994h-96.81c-4.14 0-7.5-3.359-7.5-7.497 0-4.148 3.36-7.497 7.5-7.497z" />
      <path d="m352.139 412.834h-24.135c-4.142 0-7.5 3.357-7.5 7.497s3.358 7.497 7.5 7.497h24.135c4.142 0 7.5-3.357 7.5-7.497s-3.358-7.497-7.5-7.497z" />
    </g>
    <ellipse cx="146.586" cy="255.946" fill="#ffe8cf" rx="64.484" ry="74.472" />
    <ellipse cx="229.945" cy="389.026" fill="#ffe8cf" rx="64.484" ry="74.472" />
    <g fill="#f2cdae">
      <path d="m64.484 340.239c-23.85 0-43.252 21.886-43.252 48.787 0 4.14 3.358 7.497 7.5 7.497s7.5-3.357 7.5-7.497c0-18.633 12.674-33.793 28.252-33.793s28.252 15.16 28.252 33.793-12.674 33.792-28.252 33.792c-4.142 0-7.5 3.357-7.5 7.497s3.358 7.497 7.5 7.497c23.849 0 43.252-21.885 43.252-48.786s-19.403-48.787-43.252-48.787z" />
      <path d="m190.055 255.946c0-27.039-19.5-49.037-43.469-49.037s-43.47 21.998-43.47 49.037 19.5 49.037 43.47 49.037c4.142 0 7.5-3.357 7.5-7.497s-3.358-7.497-7.5-7.497c-15.698 0-28.47-15.272-28.47-34.043s12.771-34.043 28.47-34.043 28.469 15.272 28.469 34.043c0 4.14 3.358 7.497 7.5 7.497s7.5-3.357 7.5-7.497z" />
      <path d="m229.945 338.143c-4.142 0-7.5 3.357-7.5 7.497s3.358 7.497 7.5 7.497c16.579 0 30.067 16.1 30.067 35.889s-13.488 35.888-30.067 35.888-30.067-16.1-30.067-35.888c0-4.14-3.358-7.497-7.5-7.497s-7.5 3.357-7.5 7.497c0 28.057 20.217 50.882 45.067 50.882s45.067-22.826 45.067-50.882-20.217-50.883-45.067-50.883z" />
    </g>
  </svg>
);
